import MainLayout from "@/components/layout/admin/MainLayout.vue";
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import CONFIG from "@/assets/js/config.custom.js";
import axios from "axios";

export default {
  name: "DiscountTypeList",
  components: {
    MainLayout,
    AdvancedLaravelVuePaginate,
    Loading
  },

  data() {
    return {
      isFilterOpen: false,
      noDataMsg: CONFIG.NO_DATA_FOUND,
      isLoading: false,
      discountTypeData: {},
      searchData: {
        name: '',
        discount_type: null,
        is_active: null
      },
      searchedData: null,
      isSearched: false,
      currentPage: 1,
      STATUS: CONFIG.DISCOUNT_TYPE_STATUS,
      CONDITION_DISCOUNT_TYPE: CONFIG.DISCOUNT_TYPE
    };
  },

  methods: {
    getAllDiscountType(page = 1) {
      this.currentPage = page;
      this.isLoading = true;

      axios.get('/discountType/list?page=' + page)
        .then(response => {
          this.discountTypeData = response.data;
        })
        .catch(err => {
          if (err.response && err.response.status === 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          } else {
            console.error(err);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    searchDiscountType(page = 1) {
      this.currentPage = page;
      this.isSearched = true;
      this.isLoading = true;
      this.searchedData = { ...this.searchData };

      axios.get('/discountType/search?page=' + page, {
        params: {
          name: this.searchedData.name,
          discount_type: this.searchedData.discount_type,
          is_active: this.searchedData.is_active
        }
      })
      .then(res => {
        if (res.data) {
          this.discountTypeData = res.data;
        }
      })
      .catch(err => {
        if (err.response && err.response.status === 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        } else {
          console.error(err);
        }
      })
      .finally(() => {
        this.isLoading = false;
      });
    },

    reset() {
      this.searchData.name = '';
      this.searchData.discount_type = null;
      this.searchData.is_active = null;
      this.searchedData = null;
      this.isSearched = false;
      this.isLoading = true;
      this.getAllDiscountType();
    },

    showCreate() {
      this.$router.push({ name: 'discountTypeCreate' });
    },

    showEdit(id) {
      this.$router.push({ path: `/discountType/edit/${id}` });
    },

    showDetail(id) {
      this.$router.push({ path: `/discountType/detail/${id}` });
    },

    confirmDelete(id) {
      if (window.confirm("Are you sure you want to delete this discount type?")) {
        this.deleteDiscountType(id);
      }
    },

    deleteDiscountType(id) {
      this.isLoading = true;

      axios.delete(`/discountType/delete/${id}`)
        .then(res => {
          if (res.data.success) {
            this.$notification.success('Discount Type Deleted Successfully', {
              timer: 3,
              position: "bottomCenter"
            });

            if (this.isSearched) {
              this.searchDiscountType(this.currentPage);
            } else {
              this.getAllDiscountType(this.currentPage);
            }

          } else {
            this.$notification.error('Discount Type could not be deleted.', {
              timer: 3,
              position: "bottomCenter"
            });
            this.getAllDiscountType(this.currentPage);
          }
        })
        .catch(err => {
          if (err.response && err.response.status === 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          } else {
            const errorMsg = err.response?.data?.message || "An unexpected error occurred.";
            this.$notification.error(errorMsg, {
              timer: 4,
              position: "bottomCenter"
            });
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    formatDiscountAmount(discountType, discountAmount) {
      if (discountType === CONFIG.DISCOUNT_TYPE.PERCENTAGE) {
        return discountAmount + ' %';
      }
      return discountAmount ? this.$options.filters.numFormat(discountAmount) : '';
    }
  },

  mounted() {
    this.isLoading = true;
    this.getAllDiscountType();
  }
};
